module.exports = __webpack_public_path__ + "img/bm-google-hyb.4e16929a.png";